import React, { useEffect, useMemo, useState } from 'react';
import Card from '../../components/ui/Card';
import { Select } from '../../components/ui/Input';
import { folhaPagamentoApi } from '../../api/rh';
import { diasUteisNoMes } from './beneficiosCalc';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

const MESES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
].map((m, i) => ({ value: String(i + 1), label: m }));

const ANO_ATUAL = new Date().getFullYear();
const ANOS = Array.from({ length: 5 }, (_, i) => ANO_ATUAL - 2 + i).map(a => ({ value: String(a), label: String(a) }));

function formatarReais(v) {
  return (v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

// Reaproveita a mesma tela pra Vale Transporte e Vale Alimentação — só muda qual
// campo do cadastro de benefícios do funcionário é lido (valor diário).
export default function ValeBeneficioList({ campo, titulo }) {
  useTituloPagina(titulo);
  const hoje = new Date();
  const [mes, setMes] = useState(String(hoje.getMonth() + 1));
  const [ano, setAno] = useState(String(hoje.getFullYear()));
  const [dados, setDados] = useState({ funcionarios: [], beneficios: [], ponto: [] });

  useEffect(() => {
    folhaPagamentoApi.obterDados(mes, ano).then(setDados).catch(() => {});
  }, [mes, ano]);

  const linhas = useMemo(() => {
    return dados.funcionarios.map(f => {
      const beneficio = dados.beneficios.find(b => b.funcionario_id === f.id);
      const pontoMes = dados.ponto.find(p => p.funcionario_id === f.id);
      const faltas = Number(pontoMes?.faltas) || 0;
      const diasUteis = diasUteisNoMes(Number(mes), Number(ano), f.dias_semana);
      const diasEfetivos = Math.max(0, diasUteis - faltas);
      const valorDiario = Number(beneficio?.[campo]) || 0;
      const total = valorDiario * diasEfetivos;
      return { funcionario: f, valorDiario, diasUteis, faltas, diasEfetivos, total };
    }).filter(l => l.valorDiario > 0);
  }, [dados, mes, ano, campo]);

  const totalGeral = linhas.reduce((s, l) => s + l.total, 0);

  return (
    <div>
      <Card style={{ marginBottom: 14 }}>
        <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
          <Select options={MESES} value={mes} onChange={e => setMes(e.target.value)} style={{ width: 160 }} />
          <Select options={ANOS} value={ano} onChange={e => setAno(e.target.value)} style={{ width: 110 }} />
        </div>
        <div style={{ background: COLORS.primaryBg, borderRadius: 10, padding: 14, maxWidth: 260 }}>
          <div style={{ fontSize: 11, color: COLORS.primary, textTransform: 'uppercase', fontWeight: 700 }}>Total do Mês</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: COLORS.primary }}>{formatarReais(totalGeral)}</div>
        </div>
      </Card>

      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Nome</th>
              <th style={{ padding: 10 }}>Cargo</th>
              <th style={{ padding: 10 }}>Valor Diário</th>
              <th style={{ padding: 10 }}>Dias Úteis</th>
              <th style={{ padding: 10 }}>Faltas</th>
              <th style={{ padding: 10 }}>Dias Efetivos</th>
              <th style={{ padding: 10 }}>Total a Pagar</th>
            </tr>
          </thead>
          <tbody>
            {linhas.map(l => (
              <tr key={l.funcionario.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                <td style={{ padding: 10, fontWeight: 600 }}>{l.funcionario.nome}</td>
                <td style={{ padding: 10 }}>{l.funcionario.cargo || '-'}</td>
                <td style={{ padding: 10 }}>{formatarReais(l.valorDiario)}</td>
                <td style={{ padding: 10 }}>{l.diasUteis}</td>
                <td style={{ padding: 10 }}>{l.faltas}</td>
                <td style={{ padding: 10 }}>{l.diasEfetivos}</td>
                <td style={{ padding: 10, fontWeight: 700, color: COLORS.primary }}>{formatarReais(l.total)}</td>
              </tr>
            ))}
            {linhas.length === 0 && (
              <tr><td colSpan={7} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum funcionário com esse benefício cadastrado neste período.</td></tr>
            )}
          </tbody>
          {linhas.length > 0 && (
            <tfoot>
              <tr style={{ borderTop: `2px solid ${COLORS.border}` }}>
                <td colSpan={6} style={{ padding: 10, textAlign: 'right', fontWeight: 700 }}>Total</td>
                <td style={{ padding: 10, fontWeight: 700, color: COLORS.primary }}>{formatarReais(totalGeral)}</td>
              </tr>
            </tfoot>
          )}
        </table>
      </Card>
    </div>
  );
}
